import { defaults, allowed } from '../../../../lib/genericReducer';

export default function reducer(
  state = {
    fetching: false,
    fetched: false,
    responseMessage: null,
    direct_costs: {},
    activeTab: '1',
  },
  action
) {
  // Set expected reducer types
  const types = ['DIRECT_COST'];

  if (!allowed(types, action)) return state;

  state = {
    ...state,
    ...defaults(action),
  };

  switch (action.type) {
    case 'FETCH_DIRECT_COSTS_FULFILLED': {
      return {
        ...state,
        direct_costs: action.payload,
      };
    }
    default:
      break;
  }

  return state;
}
